<template>
	<div>
		<v-row>
			<v-col cols="12" lg="12" md="12">
				<s-crud
					title="Detalles"
					add
					edit
					remove
					:config="config"
					@save="save($event)"
					:filter="filter"
					search-input
					ref="crudDetail"
				>
					<template v-slot="props">
						<v-container>
							<v-row>
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-definition
										label="Tipo de Producto"
										:def="1740"
										:add="$fun.isAdmin()"
										v-model="props.item.TypeSubstances"
										clearable
										full
									/>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-substances
										label="Sustancia"
										:type-substances="props.item.TypeSubstances"
										v-model="props.item.AsuID"
										clearable
										full
									/>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-definition
										label="Tipo de Sustancia"
										:def="1739"
										:add="$fun.isAdmin()"
										v-model="props.item.TypeSubstance"
										clearable
										full
									/>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-text
										v-model="props.item.RmdValue"
										label="Valor"
										type="number"
										decimal>
									</s-text>
								</v-col>
							</v-row>
						</v-container>
					</template>
				</s-crud>
			</v-col>
		</v-row>
	</div>
</template>
<script>
	import _sService from "../../../../services/Technicalassistance/TasRawMaterialAnalysisDetailService";
	import SSelectSubstances from "@/components/TecnicalAssistence/Substances/SSelectSubstances.vue";

	export default {
		components: {
			SSelectSubstances,
		},
		props: {
			RmnID: { type: Number, default: 0 },
		},
		data: () => ({
			filter: {
				RmnID: 0
			},
			config: {
				model: {
					RmdID: "ID",
				},
				service: _sService,
				headers: [
					{ text: "ID", value: "RmdID" },
					{ text: "Tipo de Producto", value: "TypeSubstancesName" },
					{ text: "Sustancia", value: "SubstancesName" },
					{ text: "Tipo de Sustancia", value: "TypeSubstanceName" },
					{ text: "Valor", value: "RmdValue" }
				],
			},
		}),
		watch: {
			RmnID() {
				this.Initialize();
			},
		},
		methods: {
			Initialize() {
				this.filter = { RmnID: this.RmnID };
				if (this.$refs.crudDetail) {
					this.$refs.crudDetail.refresh();
				}
			},
			save(item) {
				if (!this.RmnID || this.RmnID === 0) {
					this.$fun.alert("Debe seleccionar un Análisis de Materia Prima", "warning");
					return;
				}
				if (!item.AsuID) {
					this.$fun.alert("Debe seleccionar una Sustancia", "warning");
					return;
				}

				item.RmnID = this.RmnID;
				item.UsrCreateID = this.$fun.getUserID();
				item.UsrUpdateID = this.$fun.getUserID();
				item.SecStatus = 1;

				_sService.save(item, this.$fun.getUserID()).then(resp => {
					if (resp.status === 200) {
						this.$fun.alert("Se guardó correctamente", "success");
						this.$refs.crudDetail.refresh();
					}
				}).catch(err => {
					this.$fun.alert("Error al guardar: " + (err.message || err), "error");
				});
			},
		},
		created() {
			this.Initialize();
		}
	};
</script>
